module.exports = __webpack_public_path__ + "static/media/Epilogue-SemiBoldItalic.4988ead9.ttf";